import React, { useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import GeneralButton from '../helpers/GeneralButton';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

const ETTInstrumentInsertionUI = (props: UIProperties<ETTInstrumentInsertionUIConfig>) => {
	const [selectedButtonIndx, setSelectedButtonIndx] = useState(0);
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			<div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '800px',
				height: '640px'
			}}>
				<img style={{
					width: '100%',
					height: '70px'
				}} src="./assets/images/SBAR/header_modal_1.png"/>
				<div style={{
					position: 'absolute',
					top: '01px',
					left: '3px',
					width: '733px',
					height: '65px',
				}}>
					<p style={{
						margin: '0px',
						fontSize: '25pt',
						textAlign: 'center',
						position: 'relative',
						top: '13px'
					}} className="title-font" tabIndex={0} id='ett-instrument-insertion-ui-top'>ETT Attempt</p>
				</div>
				<div style={{
					width: '100%',
					height: '570px',
					position: 'absolute',
					top: '70px',
					left: '0'
				}}>
					<img style={{
						width: '100%',
						height: '100%'
					}} src="./assets/images/SBAR/window_modal_1_edited.png"/>

					<div style={{
						position: 'absolute',
						top: '101px',
						left: '50%',
						transform: 'translate(-50%, 0)',
						width: '422px',
						height: '65px',
					}}>
						<p style={{
							margin: '0px',
							fontSize: '15pt',
							textAlign: 'center',
							position: 'relative',
							top: '13px'
						}} className="title-font" tabIndex={0}>Select an airway instrument for insertion</p>
					</div>
					<CustomETTInstrumentInsertionButton 
						position={{
							type: 'absolute',
							left: '160px',
							top: '200px'
						}}
						text='ETT / s'
						showYellowThingyOnTheSide= {selectedButtonIndx === 0}
						onClicked={() => {
							setSelectedButtonIndx(0);
						}}
						 />
					<CustomETTInstrumentInsertionButton 
						position={{
							type: 'absolute',
							left: '440px',
							top: '200px'
						}}
						text='Bougie'
						showYellowThingyOnTheSide= {selectedButtonIndx === 1}
						onClicked={() => {
							setSelectedButtonIndx(1);
						}}
						 />
					<GeneralButtonWithText parameters= {{
						text: 'Abort',
						top: '470px',
						left: '240px',
						width: '130px',
						isDisabled: false,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: null,
						customImgStyle: {
						},
						customButtonStyle : {
						},
						customTextStyle: {
							fontSize: '12pt'
						},
						onClicked: () => {
							props.parameters.onAbortClicked();
						}
					}}/>

					<GeneralButtonWithText parameters= {{
						text: 'Next',
						top: '470px',
						left: '420px',
						width: '130px',
						isDisabled: false,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: null,
						customImgStyle: {
						},
						customButtonStyle : {
						},
						customTextStyle: {
							fontSize: '12pt'
						},
						onClicked: () => {
							props.parameters.onNextClicked(selectedButtonIndx);
						}
					}}/>
					
				</div>
				
			</div>
		</div>
	);

};

const CustomETTInstrumentInsertionButton = (props: CustomETTInstrumentInsertionConfig) => {
	const [isClicked, setIsClicked] = useState(false);
	return (
		<div style={{
			position: props.position.type ? props.position.type : 'relative',
			top: props.position.top,
			left: props.position.left,
			width: '234px',
			pointerEvents: 'none'
		}}>
			<div style={{
				position: 'relative'
			}}>
				<GeneralButtonWithText parameters= {{
					text: '',
					top: '0px',
					left: '0px',
					isDisabled: false,
					ariaLbl: props.text,
					width: '170px',
					srcIdle: './assets/images/general/buttons/button_side_large-1.png',
					srcHighlight: null,
					srcDisabled: './assets/images/general/buttons/button_side_large_disabled.png',
					customMainStyle: {
						// position: 'relative',
						// width: props.isFlipped ? '99px' : '129px',
						// transform: props.isFlipped ? 'scaleX(-1)' : 'scaleX(1)'
					},
					onClicked: () => {
						setIsClicked(true);
						if(props.onClicked) {
							props.onClicked();
						}
					}
				}}/>
				
				<div style={{
					position: 'relative',
					height: '30px',
					pointerEvents: 'none',
					width: '75%',
					left: '12px',
					top: '47px'
				}}>
					<div style={{
						position: 'relative',
						top: '50%',
						transform: 'translate(0, -50%)'
					}}>
						<p className='title-font' style={{
							textAlign: 'center',
							margin: '0',
							fontSize: '16pt',
							fontWeight: 'normal'
						}}>{props.text}</p>
					</div>
					
				</div>

				{props.showYellowThingyOnTheSide ? (
					<img style={{
						position: 'absolute',
						top: '1px',
						right: '-27px',
						width: '34px',
						pointerEvents: 'none'
					}} src="./assets/images/general/buttons/button_side_pointer.png" />
				) : (null)}
			</div>
		</div>
	);

};

interface CustomETTInstrumentInsertionConfig {
	text: string;
	showYellowThingyOnTheSide: boolean;
	position: CustomETTInstrumentInsertionButtonPosition;
	onClicked?: () => void;
}

interface CustomETTInstrumentInsertionButtonPosition {
	type?: any;
	left: string;
	top: string;
}

export interface ETTInstrumentInsertionUIConfig extends BaseConfig{
	onNextClicked: (selectedButtonIndx: number) => void;
	onAbortClicked: () => void;
}

export default ETTInstrumentInsertionUI;